<template lang="html">
  <form role="form" @submit.prevent.stop>
    <payout-form-group :label="$t('Номер карты')" :required="true" :has-errors="model.errors.has('cardNumber')">
      <filtered-input-wrapper v-model="model.values.cardNumber">
        <payout-cardnumber-input v-model="model.values.cardNumber"></payout-cardnumber-input>
      </filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="$t('card_number_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardNumber|*" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <payout-form-group :label="$t('Срок действия')" :required="true" :has-errors="model.errors.has('expirationDate')">
      <filtered-input-wrapper v-model="model.values.expirationDate">
        <!--input(type="text" v-model="model.values.expirationDate").form-control-->
        <payout-masked-input v-model="model.values.expirationDate" mask="DD/DD"></payout-masked-input>
      </filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="$t('card_expdate_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="expirationDate|*" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <template v-if="model.options.cardCurrencySupport">
      <payout-form-group :label="$t('Валюта карты')" :required="true" :has-errors="model.errors.has('cardCurrency')">
        <dropdown-keyvalue :options="cardCurrencyOptions" :placeholder="$t('Выберите валюту')" v-model="model.values.cardCurrency"></dropdown-keyvalue>
        <error-message-block #errors attribute="cardCurrency|*" :errors="model.errors"></error-message-block>
      </payout-form-group>
    </template>
    <payout-form-group>
      <h3>{{$t('Получатель')}}</h3>
    </payout-form-group>
    <payout-textfield-input-group :label="$t('Имя держателя карты')" :model="model" :required="true" :has-errors="model.errors.has('cardholderName')" attribute="cardholderName"></payout-textfield-input-group>
    <payout-textfield-input-group :label="$t('Фамилия держателя карты')" :model="model" :required="true" :has-errors="model.errors.has('cardholderSurname')" attribute="cardholderSurname"></payout-textfield-input-group>
    <payout-form-group :required="true" :label="$t('Дата рождения')" :has-errors="model.errors.has('cardholderBirthdate')">
      <payout-masked-input v-model="model.values.cardholderBirthdate" mask="DDDD-DD-DD"></payout-masked-input>
      <payout-input-hint-block #hints :hint="$t('birthdate_hint')"></payout-input-hint-block>
      <error-message-block #errors attribute="cardholderBirthdate|*" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <payout-textfield-input-group :model="model" :label="$t('Адрес получателя')" :required="true" attribute="cardholderAddress"></payout-textfield-input-group>
    <payout-textfield-input-group :model="model" :label="$t('Город')" :required="true" attribute="cardholderAddressCity"></payout-textfield-input-group>
    <payout-form-group :label="$t('Страна')" :required="true" :has-errors="model.errors.has('cardholderAddressCountry')">
      <dropdown-keyvalue :options="cardholderAddressCountriesSorted" :placeholder="$t('Выберите страну')" v-model="model.values.cardholderAddressCountry"></dropdown-keyvalue>
      <error-message-block #errors attribute="cardholderAddressCountry|*" :errors="model.errors"></error-message-block>
    </payout-form-group>
    <template v-if="model.options.beneficiaryCountryRestrictionHtml">
      <payout-hint-panel-form-group :heading="$t('Страны, недоступные для переводов')">
        <div v-html="model.options.beneficiaryCountryRestrictionHtml"></div>
      </payout-hint-panel-form-group>
    </template>
    <payout-textfield-input-group :model="model" :label="$t('Назначение')" :required="true" attribute="description"></payout-textfield-input-group>
    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>
    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>
    <!-- Будет применен курс автоконвертации ({src} = {dest})-->
    <!-- payout-destination-currency-conversion-notice-form-group(:model="model")-->
    <!-- Ожидаемая сумма зачисления-->
    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>
    <template v-if="model.options.limitsAlertText">
      <payout-toggable-hint-panel-form-group :heading="$t('Лимиты')" :link-text="$t('Информация о лимитах')">
        <div v-html="model.options.limitsAlertText"></div>
      </payout-toggable-hint-panel-form-group>
    </template>
    <payout-form-notification-block :model="model"></payout-form-notification-block>
    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {computed, defineComponent, getCurrentInstance, reactive} from "vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import {WorldcardsPaymentModel} from "@/components/forms/payout/forms/cards/cards-payments";
import PayoutMaskedInput from "@/components/forms/payout/forms/inputs/PayoutMaskedInput.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import {CurrencyCode} from "@/models/core/currency";




export default defineComponent({
  name: "WorldcardsPaymentForm",
  components: {
    PayoutToggableHintPanelFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutEvaluateFeeFormGroup,
    PayoutInputAmountFormGroup,
    PayoutHintPanelFormGroup,
    DropdownKeyvalue,
    PayoutMaskedInput,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock, PayoutCardnumberInput, FilteredInputWrapper, PayoutFormGroup},
  extends: AbstractPayoutForm,
  setup() {
    const model = reactive(new WorldcardsPaymentModel());

    const cardCurrencyOptions = computed(() => {
      const curs = [
        {currency: CurrencyCode.USD, title: 'USD - Доллар США'},
        {currency: CurrencyCode.EUR, title: 'EUR - Евро'},
      ]
      const $i18n = getCurrentInstance().proxy?.$i18n;
      let res = {};
      curs.forEach((cur) => {
        res[cur.currency] = $i18n ? $i18n.t(cur.title) : cur.title;
      });
      return res;
    });

    const cardholderAddressCountries = computed(() => {
        return model.loaded ? model.options.countries : {};
      });

    const cardholderAddressCountriesSorted = computed(() => {
      const sortedEntries = Object.entries(cardholderAddressCountries.value).map(([key, value]) => {
        return {key, value};
      }).sort((a, b) => {
        return String(a.value).localeCompare(String(b.value));
      });

      let result = {};

      sortedEntries.forEach((entry) => {
        result[entry.key] = entry.value;
      });

      return result;
      // let countries: any = cardholderAddressCountries;
      //
      // let names = _.values(countries).sort((function (a, b) {
      //   return a.localeCompare(b);
      // }));
      // let v2k = _.invert(countries);
      // let result: any = {};
      //
      // for (let name of names) {
      //   result[v2k[name]] = name;
      // }
      //
      // return result;
    });

    return {
      model,
      cardCurrencyOptions,
      cardholderAddressCountriesSorted
    }
  }
})
</script>

<style scoped>

</style>

<i18n>
{
  "ru": {
    "card_number_hint": "Номер карты получателя. Пример: 1234 5678 9012 3456",
    "card_expdate_hint": "Срок действия карты ММ/ГГ. Пример: 12/21",
    "birthdate_hint": "Дата рождения получателя. Пример: 2000-12-31"
  },
  "en": {
    "USD - Доллар США": "USD - US Dollar",
    "EUR - Евро": "EUR - Euro",
    "Валюта карты": "Card currency",
    "Выберите валюту": "Select currency",
    "Адрес получателя": "Cardholder address",
    "birthdate_hint": "Date of birth. Example: 2000-12-31",
    "Имя держателя карты": "Cardholder name",
    "Фамилия держателя карты": "Cardholder surname",
    "Назначение": "Description",
    "card_number_hint": "Card number of the recipient. Example: 1234 5678 9012 3456",
    "Номер карты": "Card number",
    "Срок действия": "Expiration date",
    "Получатель": "Recipient",
    "Дата рождения": "Birth date",
    "Страна": "Country",
    "Выберите страну": "Select country",
    "Страны, недоступные для переводов": "Countries unavailable for transfers",
    "Лимиты": "Limits",
    "Информация о лимитах": "Information about limits",
    "card_expdate_hint": "Card expiration date MM/YY. Example: 12/21",
    "Адрес": "Address",
    "Город": "City"
  }
}
</i18n>
